<div class="upload-container" [class.has-border]="hasBorder">
  <div
    class="p-4 dropzone"
    [class.dragover]="isDragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <h2 *ngIf="isDragOver"><svg-icon key="upload"></svg-icon>Drop your file here</h2>

    <form hidden>
      <input type="file" accept="image/*" (change)="onFileInputChange($event)" #fileInput data-testid="file-upload-input" />
    </form>

    <div [class.blurred]="isDragOver">
      <div class="upload-content">
        <div class="upload-metadata" [class.vertical]="verticalLayout">
          <p class="text-normal-bold title mb-3" [class.required]="required">{{ vm?.title }}</p>
          <div>
            <p *ngIf="vm?.imageRequirements.length" class="text-tiny-bold requirements">Image requirements:</p>
            <p *ngFor="let requirement of vm?.imageRequirements" class="text-tiny" [innerHTML]="requirement"></p>
            <p *ngIf="shouldShowPNGLabel" class="png-recommendation">You must upload a .png image!</p>
          </div>
        </div>
        <div class="d-flex preview" [class.vertical]="verticalLayout">
          <div class="image-container">
            <img
              *ngIf="value?.publicUrl"
              [src]="value.publicUrl"
              [class.dark-bcg]="hasDarkImageBackground"
              alt="picture_preview"
              data-testid="uploaded-image"
              (load)="previewLoaded()"
            />
          </div>
          <div class="image-delete-icon-container" *ngIf="hasDeleteOption && !isDisabled && imageLoaded && !readonly">
            <svg-icon
              *ngIf="hasDeleteOption && !isDisabled"
              key="image-delete-trash"
              class="trash-icon"
              (click)="onDeleteFileClick()"
              data-testid="delete-image-icon"
            ></svg-icon>
          </div>
        </div>
        <button
          [disabled]="isDisabled"
          [class.vertical]="verticalLayout"
          class="upload-btn secondary mb-2 align-self-center"
          (click)="onUploadClick()"
          [attr.data-testid]="uploadButtonTestId"
        >
          <div class="d-flex align-items-center">
            <svg-icon key="plus" size="md" class="mr-1"></svg-icon>
            <span> Upload image</span>
          </div>
        </button>
      </div>
      <div *ngIf="value?.name" class="preview-text d-flex align-items-center">
        <svg-icon key="check" size="md" class="green"></svg-icon>
        <span
          [matTooltip]="value.name.length < fileNameEllipsisThreshold ? undefined : value.name"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip"
          class="image-name ml-1"
          >{{ value.name }}</span
        >
      </div>
    </div>
  </div>
</div>
